import { render, staticRenderFns } from "./ItemGroupCard.vue?vue&type=template&id=4516f310&scoped=true&"
import script from "./ItemGroupCard.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4516f310",
  null
  
)

export default component.exports